import { useMemo } from 'react'

import { getPrimaryTradeName } from '../utils/getPrimaryTradeName'
import { useZervantSettings } from './useZervantSettings'

export const useDefaultTradeName = () => {
  const { data: zervantSettings, hasFailedToLoad, isLoading, refetch } = useZervantSettings()

  const defaultTradeName = useMemo(
    () => getPrimaryTradeName(zervantSettings?.values?.company?.tradeNames),
    [zervantSettings],
  )

  return { defaultTradeName, hasFailedToLoad, isLoading, refetch }
}
